import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Button, Icon, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import SendTicket from './SendTicket';
import globalStyles from '../styles';

const styles = theme => ({
    buttons: {
        marginTop: '20px',
        display: 'block'
    },
    button: {
        margin: '5px 5px'
    },
    icon: {
        fontSize: '16px',
        marginLeft: '5px'
    },
    mobileButtons: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            justifyContent: 'center'
        }
    },
    mobileButton: {
        margin: '5px'
    },
    mobileIcon: {
        '& > img': {
            width: '19px'
        },
        width: '19px',
        marginLeft: '5px'
    },
    subheading: {
        margin: '20px 0 10px'
    },
    paragraph: {
        fontSize: '16px',
        marginBottom: '10px',
        fontWeight: '100'
    },
    link: globalStyles.link,
    emailInput: {
        maxWidth: 184
    },
    sendButton: {
        height: '56px',
        margin: '0 0 0 10px',
        padding: '0.6em'
    },
    form: {
        marginTop: 30
    }
});

const getWhatsAppLink = viewTicketLink =>
    `whatsapp://send?text=Your ShuttleID bus ticket can be viewed here: ${viewTicketLink}`;

const getMessengerLink = viewTicketLink =>
    `fb-messenger://share/?link=${viewTicketLink}`;

const ViewTicketButtons = ({ ticketId, hasNotifications, classes }) => {
    const viewTicketBaseLink = process.env.REACT_APP_VIEW_TICKET_BASE_URL;
    const viewTicketLink = `${viewTicketBaseLink}${ticketId}`;

    return (
        <div style={{ marginBottom: 30 }}>
            <div className={classes.buttons}>
                <Button
                    className={classes.button}
                    variant="outlined"
                    color="primary"
                    component="a"
                    href={`${viewTicketLink}`}
                    target="_blank"
                >
                    View ticket
                    <Icon className={classes.icon}>confirmation_number</Icon>
                </Button>
                <Button
                    className={classes.button}
                    variant="outlined"
                    color="primary"
                    component="a"
                    href={`${viewTicketLink}?print=true`}
                    target="_blank"
                >
                    Print ticket
                    <Icon className={classes.icon}>print</Icon>
                </Button>
                {hasNotifications && (
                    <Button
                        className={classes.button}
                        variant="outlined"
                        color="primary"
                        component={Link}
                        to={`/ticket/${ticketId}/notifications`}
                        style={{
                            marginLeft: 10
                        }}
                    >
                        Notifications
                        <Icon className={classes.icon}>notifications_none</Icon>
                    </Button>
                )}
            </div>
            <Typography className={classes.subheading} variant="h6">
                Send ticket to passenger
            </Typography>
            <Typography className={classes.paragraph} variant="body2">
                The ticket can be printed or presented directly on the passenger
                {"'"}s mobile&nbsp;device.
            </Typography>

            <Typography className={classes.paragraph} variant="body2">
                Enter the passenger email or mobile number below and we{"'"}ll
                send the private ticket link to open on their device.
            </Typography>

            <SendTicket customerTicketId={ticketId} />

            <div className={classes.mobileButtons}>
                <Typography className={classes.subheading} variant="h6">
                    Other ways to send your ticket link
                </Typography>
                <Button
                    className={classes.mobileButton}
                    variant="outlined"
                    color="primary"
                    component="a"
                    href={getWhatsAppLink(viewTicketLink)}
                    data-action="share/whatsapp/share"
                >
                    WhatsApp ticket link{' '}
                    {/* <img
                        className={classes.mobileIcon}
                        src="/img/whatsapp.png"
                        alt="WhatsApp"
                    /> */}
                </Button>
                <Button
                    className={classes.mobileButton}
                    variant="outlined"
                    color="primary"
                    component="a"
                    href={getMessengerLink(viewTicketLink)}
                >
                    Messenger ticket link{' '}
                    {/* <img
                        className={classes.mobileIcon}
                        src="/img/facebook-messenger.png"
                        alt="Messenger"
                    /> */}
                </Button>
            </div>
        </div>
    );
};

ViewTicketButtons.propTypes = {
    ticketId: PropTypes.string.isRequired,
    classes: PropTypes.shape().isRequired
};

export default withStyles(styles)(ViewTicketButtons);
